import axios from 'axios';
import { Container } from 'emrn-hybrid/Container';
import { Logger } from 'emrn-hybrid/Logger';
import { Passport } from 'emrn-hybrid/Passport';
import { Platform } from 'react-native';
import config from '../config';

/**
 * 积分中心获取剩余抽奖机会
 */
export async function getDataFromPoint(taskId: string): Promise<any> {
  const url = config.pointLink + 'GetUserLotteryCount?TaskId=' + taskId;
  const [{ info: passport }, device, app] = await Promise.all([
    Passport.getUserInfo(),
    Container.getDeviceInfo(),
    Container.getApplicationInfo(),
  ]);

  let option2 = {
    'Content-Type': 'application/json;charset=utf-8',
    'EM-MD': device.uniqueId || 'wechat_share',
    'EM-OS': Platform.OS,
    'EM-VER': app.appVersionName || '',
    Ctoken: passport?.cToken,
    Utoken: passport?.uToken,
    Appkey: config.pointAppkey,
  };
  const param = {
    method: 'get',
    url: url,
    headers: option2,
    timeout: 15 * 1e3,
  };
  return request(param);
}

function request(options: any) {
  console.log('%c [request]:', 'color: #3381e3', options);
  Logger.info({
    tag: '邀新活动',
    msg: `[积分中心获取剩余抽奖机会接口入参]: ${JSON.stringify(options)}`,
  });
  return new Promise((resolve, reject) => {
    axios(options)
      .then(res => {
        const status = res.status;
        if (status === 200) {
          console.log(`%c [response] ${options.url}: `, 'color: #ea5504', res.data);
          const { code, message } = res.data;
          Logger.info({
            tag: '邀新活动',
            msg: `[请求成功(${options.url})]: code=${code}, message=${message} 请求数据data=${res.data}`,
          });
          return resolve(res.data);
        } else {
          Logger.info({
            tag: '邀新活动',
            msg: `[请求失败(${options.url})]: status = ${status}`,
          });
          reject(status);
        }
      })
      .catch(error => {
        Logger.info({
          tag: '邀新活动',
          msg: `[请求失败(${options.url})]: ${error}`,
        });
        console.log(`[request on error]: ${error.stack}`);
        reject(error);
      });
  });
}
